// routes/playground.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/playground')

export const handle = { name: '' }

export default dynamic(getClientModule, { ssr: false })
